import { globals } from "@client/globals";
import { MediaType } from "@client/types";
import i18n from "@common/lib/i18n";
import { validators } from "@common/lib/validate";
import { makeUrl } from "./string";

export const getNoImageUrl = () => getAssetUrl("img/other/no-image.png", MediaType.Image);

export const isAbsoluteUrl = (url: string) => (url || "").indexOf("http") === 0;

// NOTE: we can use common i18n because the message isn't used
export const isUrl = (url: string) => !validators.absoluteUrl(i18n, url) || !validators.relativeUrl(i18n, url);

const isInternalMediaUrl = (url: string) => (url || "").startsWith("int-");
const isInternalRelativeMediaUrl = (url: string) => (url || "").includes("/internal");
export const isAwsCommonUrl = (url: string) => (url || "").startsWith("/common");
export const isSiteMediaUrl = (url: string) => (url || "").startsWith("/site");
export const isUploadsMediaUrl = (url: string) => (url || "").indexOf("/") === -1;
export const isUploadsRelativeMediaUrl = (url: string) => (url || "").includes("/uploads");
export const isMediaServiceUrl = (url: string) => (url || "").includes(globals.paths.mediaServiceUrl);
export const isFontAwesomeIcon = (url: string) =>
  url.match(/^fa(r|s|l)?\s+/i) ||
  url.startsWith("fa-brands") ||
  url.startsWith("fa-light") ||
  url.startsWith("fa-regular") ||
  url.startsWith("fa-solid") ||
  url.startsWith("fa-thin");
export const isInline = (url: string) => url.indexOf("data:image") === 0;
export const isSiteRootUrl = (url: string) => (url || "").startsWith("~") || /^\/portals/i.test(url);
export const isAssetUrl = (url: string) => url.indexOf("img/") >= 0;

export type GetAssetUrlShort = (url: string | undefined | null, type: MediaType) => string;
export const getAssetUrl = (url: string | undefined | null, type: MediaType) => {
  if (!url) return "";

  if (url.startsWith("#")) return `${globals.paths.assetsUrl}/img/icons.svg?c=3${url}`;
  if (isFontAwesomeIcon(url)) return url;
  if (isInline(url)) return url;
  if (isAbsoluteUrl(url)) return url;
  if (isInternalMediaUrl(url)) return `${globals.paths.internalMediaUrl}/${type}/${url}`;
  if (isUploadsMediaUrl(url)) return `${globals.paths.uploadsMediaUrl}/${type}/${url}`;
  if (isInternalRelativeMediaUrl(url) || isUploadsRelativeMediaUrl(url))
    return makeUrl(globals.paths.awsS3RootUrl, url);
  if (isMediaServiceUrl(url)) return url;
  if (isSiteMediaUrl(url)) return url;
  if (isSiteRootUrl(url)) {
    url = `/${url.replace(/^[~/]*/, "")}`;
    return url.includes(globals.paths.baseUrl) ? url : makeUrl(globals.paths.baseUrl, url);
  }
  if (isAwsCommonUrl(url)) return makeUrl(globals.paths.awsS3RootUrl, url);
  if (url.startsWith("/")) return makeUrl(globals.paths.awsS3Url, url);

  return `${globals.paths.awsS3RootUrl}/releases/common/next/assets/${url}`;
};
